module.exports = __webpack_public_path__ + "img/wahoo-bay-poster.397f22f7.jpg";